import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBuildKnowledge = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.8907 9.79629C10.8264 11.246 9.07554 11.5495 8.22587 10.7251C7.8242 11.5036 6.99427 11.4999 6.6295 11.4008L5.83203 13.2877C5.82377 13.3072 5.80532 13.3198 5.78496 13.3198H4.6598C4.63136 13.3198 4.6083 13.2956 4.6083 13.2658V12.1171C1.19673 11.9144 1.63444 9.4773 2.47124 9.04936C0.952124 7.60336 1.95629 6.29696 2.47124 5.77892C2.66082 5.24474 3.07632 4.44101 3.99036 4.17073M13.8649 6.34781C14.6991 7.59109 14.3733 9.1135 13.247 9.79756C12.4984 10.2523 11.4383 10.1871 10.8911 9.79756C10.3233 9.39343 10.0018 8.69576 10.0543 8.14523M11.3423 3.69711C10.5579 3.23506 8.92194 2.22571 6.8364 2.91493M4.35018 5.21187C3.07595 3.53545 6.02406 1.42723 7.59907 3.77745M12.4822 7.58803C15.0827 6.92583 13.3061 2.43909 10.1778 4.06079M10.8139 6.07605C10.4921 6.6031 8.75414 6.68416 8.75414 5.10303M9.17887 6.19938C9.0372 6.51921 8.5686 7.11296 7.82707 6.92916M6.8364 8.8359C6.41604 9.4931 4.64518 9.4649 4.58258 8.0003",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgBuildKnowledge;
